import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Store} from '@ngrx/store';
import {AppState} from '@store/state/app.state';
import {catchError, switchMap, take, tap, timeout} from 'rxjs/operators';
import {EnvironmentService} from '@iw-shop/core/services/environment.service';
import {first, Observable, of, TimeoutError} from 'rxjs';
import {ApiDynamicArticle, ApiDynamicArticlesGetRequest, ApiDynamicArticlesGetResponse} from '@api/dynamic-articles';
import {ApiShoppingCartsUpdateRequest, ApiShoppingCartsUpdateResponse} from "@api/shopping-carts";
import {increaseRequestsCounter, increaseRequestsDone} from "@store/actions/shopping-cart.action";
import {ShoppingCartState} from "@store/state/shopping-cart";

@Injectable({
  providedIn: 'root'
})
export class DynamicArticleService {

  constructor(private http: HttpClient, private store: Store<AppState>, private environmentService: EnvironmentService) {
  }
    getShoppingCartRequestsCounter(): number {
        let value: number = 0;
        this.store.select(state => state.shoppingCart).pipe(take(1))
            .subscribe(
                r => {
                    if (r.requestsCounter) {
                        value = r.requestsCounter;
                    }
                }
            );
        return value;
    }

    setRequestsDone() {
        this.store.dispatch(increaseRequestsDone());
    }

    getByCategory(jsonId: string, categories: ApiDynamicArticle['category'][] ): Observable<ApiDynamicArticlesGetResponse | null> {
        const body: ApiDynamicArticlesGetRequest = {
            id: jsonId,
            command: 'dynamicArticles/get',
            params: {
                filters: [{fields: ['category'], values: categories as any}],
                dynamicArticles: {
                    sort: [{field: 'position', direction: 1}]
                }
            }
        };


        let copyOfRequestCounter = this.getShoppingCartRequestsCounter();
        this.store.dispatch(increaseRequestsCounter());
        return this.store.select(state => state.shoppingCart).pipe(
            first(state => (state.requestsDone == (copyOfRequestCounter))),
            timeout(1000),
            catchError(error => {
                if (error instanceof TimeoutError) {
                    // Handle timeout error here, for example
                    console.error('Timeout has occurred');
                    return of(null);
                } else {
                    // Rethrow the error if it's not a timeout
                    throw error;
                }
            }),
            take(1),
            switchMap(r => {
                console.log('dynamicArticle: getByCategory');
                let shoppingCart: ShoppingCartState | undefined = undefined;
                this.store.select(state => state.shoppingCart).pipe(take(1)).subscribe(cart => shoppingCart = cart);
                const currentCart = shoppingCart || r;
                if (currentCart?.id && (currentCart.items?.articles?.length ?? 0) > 0) {
                    body.params.dynamicArticles.onlyPossibilitiesFromShoppingCartId = currentCart.id;
                } else if (body.params.dynamicArticles.onlyPossibilitiesFromShoppingCartId) {
                    delete body.params.dynamicArticles.onlyPossibilitiesFromShoppingCartId;
                }
                return this.http.post<ApiDynamicArticlesGetResponse>(this.environmentService.environment.urlApi, JSON.stringify(body)).pipe(
                    tap(
                        () => {
                            this.setRequestsDone();
                            console.log('dynamicArticle: getByCategory done');
                        }
                    ),
                    catchError(err => {
                        this.setRequestsDone();

                        console.log('Handling error locally and rethrowing it...', err);
                        throw err;
                    })
                );
            })
        );

    }

    get(jsonId: string, params: ApiDynamicArticlesGetRequest['params']): Observable<ApiDynamicArticlesGetResponse> {
        const body: ApiDynamicArticlesGetRequest = {id: jsonId, command: 'dynamicArticles/get', params};
        let copyOfRequestCounter = this.getShoppingCartRequestsCounter();
        this.store.dispatch(increaseRequestsCounter());
        return this.store.select(state => state.shoppingCart).pipe(
            first(state => (state.requestsDone == (copyOfRequestCounter))),
            timeout(1000),
            catchError(error => {
                if (error instanceof TimeoutError) {
                    // Handle timeout error here, for example
                    console.error('Timeout has occurred');
                    return of(null);
                } else {
                    // Rethrow the error if it's not a timeout
                    throw error;
                }
            }),
            take(1),
            switchMap(r => {
                console.log('dynamicArticle: get');
               return this.http.post<ApiDynamicArticlesGetResponse>(this.environmentService.environment.urlApi, JSON.stringify(body)).pipe(
                    tap(
                        () => {
                            this.setRequestsDone();
                            console.log('dynamicArticle: get done');
                        }
                    ),
                    catchError(err => {
                        this.setRequestsDone();

                        console.log('Handling error locally and rethrowing it...', err);
                        throw err;
                    })
                );
            })
        );


    }

/*
    getByCategory(jsonId: string, categories: ApiDynamicArticle['category'][] ): Observable<ApiDynamicArticlesGetResponse | null> {
    let shoppingCartId: string | undefined = undefined;
    this.store.select(state => state.shoppingCart).pipe(take(1)).subscribe(r => shoppingCartId = r?.id);

      const body: ApiDynamicArticlesGetRequest = {
        id: jsonId,
        command: 'dynamicArticles/get',
        params: {
          filters: [{fields: ['category'], values: categories as any}],
          dynamicArticles: {
            sort: [{field: 'position', direction: 1}]
          }
        }
      };
      if (shoppingCartId) {
          body.params.dynamicArticles.onlyPossibilitiesFromShoppingCartId = shoppingCartId;
      }
      return this.http.post<ApiDynamicArticlesGetResponse>(this.environmentService.environment.urlApi, JSON.stringify(body));
  }

    get(jsonId: string, params: ApiDynamicArticlesGetRequest['params']): Observable<ApiDynamicArticlesGetResponse> {
        const body: ApiDynamicArticlesGetRequest = {id: jsonId, command: 'dynamicArticles/get', params};
        return this.http.post<ApiDynamicArticlesGetResponse>(this.environmentService.environment.urlApi, JSON.stringify(body));
    }
*/



}
